import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Icon from "./Icon";
import { AppUtils, SignolUtils } from "@src/utils";
import { useAuthContext } from "@src/context";
import {
  COMMON_CONTROLS,
  selectOptionsAllColourHexCodes,
} from "@src/stories/utils";

const BackButton = ({
  onCustomBack = undefined,
  noContainer = false,
  trackingActionKey = undefined,
}) => {
  const auth = useAuthContext();
  const navigate = useNavigate();

  const timeoutRef = React.useRef(null);
  React.useEffect(() => {
    //On unmount, clear the timeout
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const defaultOnClick = () => {
    const originalPath = window.location.pathname;
    navigate(-1);
    timeoutRef.current = setTimeout(() => {
      if (window.location.pathname === originalPath) {
        //it didn't actually navigate, go to the overview page
        navigate(`/dashboard/${auth.activeRoleRoutePrefix}/overview`, {
          replace: true,
        });
      }
    }, 100);
  };

  return (
    <button
      className={`rounded-full w-11 h-11 cursor-pointer 
        transition-all duration-75 hover:-translate-y-px active:translate-y-px
        ${
          noContainer
            ? "text-neutral-300 hover:text-neutral-500"
            : "text-black bg-white shadow-md hover:shadow-lg active:shadow"
        }`}
      onClick={!!onCustomBack ? onCustomBack : defaultOnClick}
      {...SignolUtils.makeTrackableDataAttributes({
        actionKey: trackingActionKey,
      })}
    >
      <Icon
        name="chevronLeft"
        size={noContainer ? "sm" : "xs"}
        textColor={"currentColor"}
        backgroundColor="transparent"
        padding={false}
        centered={true}
      />
    </button>
  );
};

export const backButtonControls = {
  onCustomBack: {
    propType: PropTypes.func,
    disable: true,
    description: "Custom click event, to override the default 'navigate back'",
  },
  noContainer: {
    propType: PropTypes.bool,
    description: "if true, skips the outer white circle",
  },
  iconColor: {
    propType: PropTypes.string,
    controlType: "select",
    options: selectOptionsAllColourHexCodes([300], "name-shade"),
  },
  trackingActionKey: COMMON_CONTROLS.trackingActionKey,
};

BackButton.propTypes = AppUtils.getPropTypeFromControls(backButtonControls);

export default BackButton;
